import LocalizedStrings from "react-localization";
import LocalText from "src/local";

const localizationStrings = new LocalizedStrings({
  ja: {
    navigationBarSignUpTitle:
      LocalText.screens.authSignup.navigationBarSignUpTitle,
    inputNicknamePlaceholder:
      LocalText.screens.authSignup.inputNicknamePlaceholder,
    inputEmailPlaceholder: LocalText.screens.authSignup.inputEmailPlaceholder,
    inputPasswordPlaceholder:
      LocalText.screens.authSignup.inputPasswordPlaceholder,
    inputPasswordConfirmPlaceholder:
      LocalText.screens.authSignup.inputPasswordConfirmPlaceholder,
    inputNicknameValidationRequire:
      LocalText.screens.authSignup.inputNicknameValidationRequire,
    inputEmailValidationRequire:
      LocalText.screens.authSignup.inputEmailValidationRequire,
    inputEmailValidationFormat:
      LocalText.screens.authSignup.inputEmailValidationFormat,
    inputPasswordValidationRequire:
      LocalText.screens.authSignup.inputPasswordValidationRequire,
    inputPasswordConfirmValidationRequire:
      LocalText.screens.authSignup.inputPasswordConfirmValidationRequire,
    btnSignUpSendCode: LocalText.screens.authSignup.btnSignUpSendCode,
    btnSignUpCancel: LocalText.screens.authSignup.btnSignUpCancel,
    navigationBarConfirmTitle:
      LocalText.screens.authSignup.navigationBarConfirmTitle,
  },
});

export { localizationStrings };
